<!-- <c-header> -->
<ng-container>
  <c-container [fluid]="true" class="d-flex align-items-center justify-content-between">
    
    <!-- Left Side: Sidebar Menu Toggle -->
    <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="ps-1">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>

    <!-- Center/Spacer: Empty navs to maintain flexible structural padding -->
    <c-header-nav class="d-none d-lg-flex me-auto"></c-header-nav>
    <c-header-nav class="d-none d-lg-flex"></c-header-nav>

    <!-- Right Side: Pushed neatly to the right margin using ms-auto -->
    <c-header-nav class="ms-auto me-2">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>

  </c-container>
</ng-container>
<!-- </c-header> -->

<!-- User Dropdown Component Template -->
<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">

    <!-- Flexbox applied here ensures text and avatar remain vertically centered -->
    <button cButton color="link" [caret]="false" cDropdownToggle class="py-0 d-flex align-items-center gap-2 text-decoration-none border-0">
      <span class="text-dark fw-bold">{{ username?.user_name || 'SV' }}</span>
      <c-avatar cTextColor="primary" shape="rounded-1" size="md" src="./assets/img/avatars/SV.png" status="success">
      </c-avatar>
    </button>

    <!-- Dropped fixed widths and rigid paddings to let items adjust naturally -->
    <ul cDropdownMenu class="pt-0 pb-0 overflow-hidden shadow-sm">
      <li>
        <h6 cDropdownHeader class="bg-light fw-semibold py-2 px-3 m-0">Settings</h6>
      </li>
      
      <li>
        <a routerLink="./" cDropdownItem class="d-flex align-items-center px-3 py-2">
          <svg cIcon class="me-2" name="cilUser"></svg> Profile
        </a>
      </li>

      <li>
        <hr cDropdownDivider class="my-0" />
      </li>

      <li>
        <a routerLink="./" (click)="logout()" cDropdownItem class="d-flex align-items-center px-3 py-2 text-danger">
          <svg cIcon class="me-2" name="cilLockLocked"></svg> Logout
        </a>
      </li>
    </ul>

  </c-dropdown>
</ng-template>
